import { LayerSpecificationWithZIndex } from './types'

const layers: LayerSpecificationWithZIndex[] = [
    {
        id: 'water',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'water',
        filter: ['==', '$type', 'Polygon'],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'fill-color': 'rgb(194, 200, 202)',
            'fill-antialias': true,
        },
    },
    {
        id: 'landcover_ice_shelf',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'landcover',
        maxzoom: 8,
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'subclass', 'ice_shelf']],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'fill-color': 'hsl(0, 0%, 98%)',
            'fill-opacity': 0.7,
        },
    },
    {
        id: 'landuse_residential',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'landuse',
        maxzoom: 16,
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'class', 'residential']],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'fill-color': 'rgb(234, 234, 230)',
            'fill-opacity': ['interpolate', ['exponential', 0.6], ['zoom'], 8, 0.8, 9, 0.6],
        },
    },
    {
        id: 'waterway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'waterway',
        filter: ['all', ['==', '$type', 'LineString']],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsl(195, 17%, 78%)',
        },
    },
    {
        id: 'water_name',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'water_name',
        filter: ['==', '$type', 'LineString'],
        layout: {
            'text-field': '{name:latin}\n{name:nonlatin}',
            'symbol-placement': 'line',
            'text-rotation-alignment': 'map',
            'symbol-spacing': 500,
            'text-font': ['Open Sans Regular'],
            'text-size': 12,
        },
        paint: {
            'text-color': 'rgb(157,169,177)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
        },
    },
    {
        id: 'building',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'building',
        minzoom: 12,
        paint: {
            'fill-color': 'rgb(234, 234, 229)',
            'fill-outline-color': 'rgb(219, 219, 218)',
            'fill-antialias': true,
        },
    },
    {
        id: 'tunnel_motorway_casing',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'brunnel', 'tunnel'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'butt',
            'line-join': 'miter',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(213, 213, 213)',
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 3, 20, 40],
        },
    },
    {
        id: 'tunnel_motorway_inner',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'brunnel', 'tunnel'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(234,234,234)',
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
        },
    },
    {
        id: 'aeroway-taxiway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'aeroway',
        minzoom: 12,
        filter: ['all', ['in', 'class', 'taxiway']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsl(0, 0%, 88%)',
            'line-width': ['interpolate', ['exponential', 1.55], ['zoom'], 13, 1.8, 20, 20],
        },
    },
    {
        id: 'aeroway-runway-casing',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'aeroway',
        minzoom: 11,
        filter: ['all', ['in', 'class', 'runway']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsl(0, 0%, 88%)',
            'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 4, 17, 55],
        },
    },
    {
        id: 'aeroway-area',
        type: 'fill',
        source: 'openmaptiles',
        'source-layer': 'aeroway',
        minzoom: 4,
        filter: ['all', ['==', '$type', 'Polygon'], ['in', 'class', 'runway', 'taxiway']],
        layout: {
            visibility: 'visible',
        },
        paint: {
            'fill-opacity': ['interpolate', ['linear'], ['zoom'], 13, 0, 14, 1],
            'fill-color': 'rgba(255, 255, 255, 1)',
        },
    },
    {
        id: 'aeroway-runway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'aeroway',
        minzoom: 11,
        maxzoom: 24,
        filter: ['all', ['in', 'class', 'runway'], ['==', '$type', 'LineString']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgba(255, 255, 255, 1)',
            'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 4, 17, 50],
        },
    },
    {
        id: 'highway_minor',
        type: 'line',
        metadata: {
            'mapbox:group': 'b6371a3f2f5a9932464fa3867530a2e5',
        },
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 8,
        filter: ['all', ['==', '$type', 'LineString'], ['in', 'class', 'minor', 'service', 'track']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsl(0, 0%, 88%)',
            'line-width': ['interpolate', ['exponential', 1.55], ['zoom'], 13, 1.8, 20, 20],
            'line-opacity': 0.9,
        },
    },
    {
        id: 'highway_major_casing',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 11,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['in', 'class', 'primary', 'secondary', 'tertiary', 'trunk'],
        ],
        layout: {
            'line-cap': 'butt',
            'line-join': 'miter',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(213, 213, 213)',
            'line-dasharray': [12, 0],
            'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 10, 3, 20, 23],
        },
    },
    {
        id: 'highway_major_inner',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 11,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['in', 'class', 'primary', 'secondary', 'tertiary', 'trunk'],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': '#fff',
            'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 10, 2, 20, 20],
        },
    },
    {
        id: 'highway_major_subtle',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        maxzoom: 11,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['in', 'class', 'primary', 'secondary', 'tertiary', 'trunk'],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsla(0, 0%, 85%, 0.69)',
            'line-width': 2,
        },
    },
    {
        id: 'highway_motorway_casing',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['!in', 'brunnel', 'bridge', 'tunnel'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'butt',
            'line-join': 'miter',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(213, 213, 213)',
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 3, 20, 40],
            'line-dasharray': [2, 0],
        },
    },
    {
        id: 'highway_motorway_inner',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['!in', 'brunnel', 'bridge', 'tunnel'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': ['interpolate-hcl', ['linear'], ['zoom'], 6, 'hsla(0, 0%, 85%, 0.53)', 8, '#fff'],
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
        },
    },
    {
        id: 'highway_motorway_subtle',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        maxzoom: 6,
        filter: ['all', ['==', '$type', 'LineString'], ['==', 'class', 'motorway']],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'hsla(0, 0%, 85%, 0.53)',
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3],
        },
    },
    {
        id: 'railway_transit',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 16,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'class', 'transit'], ['!in', 'brunnel', 'tunnel']],
        ],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#dddddd',
            'line-width': 3,
        },
    },
    {
        id: 'railway_transit_dashline',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 16,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'class', 'transit'], ['!in', 'brunnel', 'tunnel']],
        ],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#fafafa',
            'line-width': 2,
            'line-dasharray': [3, 3],
        },
    },
    {
        id: 'railway_service',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 16,
        filter: ['all', ['==', '$type', 'LineString'], ['all', ['==', 'class', 'rail'], ['has', 'service']]],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#dddddd',
            'line-width': 3,
        },
    },
    {
        id: 'railway_service_dashline',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 16,
        filter: ['all', ['==', '$type', 'LineString'], ['==', 'class', 'rail'], ['has', 'service']],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#fafafa',
            'line-width': 2,
            'line-dasharray': [3, 3],
        },
    },
    {
        id: 'railway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 13,
        filter: ['all', ['==', '$type', 'LineString'], ['all', ['!has', 'service'], ['==', 'class', 'rail']]],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#dddddd',
            'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 9, 2, 20, 7],
        },
    },
    {
        id: 'railway_dashline',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 13,
        filter: ['all', ['==', '$type', 'LineString'], ['all', ['!has', 'service'], ['==', 'class', 'rail']]],
        layout: {
            visibility: 'visible',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#fafafa',
            'line-width': ['interpolate', ['exponential', 1.3], ['zoom'], 9, 1, 20, 6],
            'line-dasharray': [3, 3],
        },
    },
    {
        id: 'highway_motorway_bridge_casing',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'brunnel', 'bridge'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'butt',
            'line-join': 'miter',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(213, 213, 213)',
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 5.8, 0, 6, 5, 20, 45],
            'line-dasharray': [2, 0],
        },
    },
    {
        id: 'highway_motorway_bridge_inner',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'transportation',
        minzoom: 6,
        filter: [
            'all',
            ['==', '$type', 'LineString'],
            ['all', ['==', 'brunnel', 'bridge'], ['==', 'class', 'motorway']],
        ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': ['interpolate-hcl', ['linear'], ['zoom'], 5.8, 'hsla(0, 0%, 85%, 0.53)', 6, '#fff'],
            'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 4, 2, 6, 1.3, 20, 30],
        },
    },
    {
        id: 'highway_name_motorway',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'transportation_name',
        filter: ['all', ['==', '$type', 'LineString'], ['==', 'class', 'motorway']],
        layout: {
            'text-size': 10,
            'symbol-spacing': 350,
            'text-font': ['Open Sans Regular'],
            'symbol-placement': 'line',
            visibility: 'visible',
            'text-rotation-alignment': 'viewport',
            'text-pitch-alignment': 'viewport',
            'text-field': '{ref}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'hsl(0, 0%, 100%)',
            'text-translate': [0, 2],
            'text-halo-width': 1,
            'text-halo-blur': 1,
        },
    },
    {
        id: 'boundary_state',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'boundary',
        filter: ['==', 'admin_level', 4],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
            visibility: 'visible',
        },
        paint: {
            'line-color': 'rgb(230, 204, 207)',
            'line-width': ['interpolate', ['linear'], ['zoom'], 3, 1, 22, 15],
            'line-blur': 0.4,
            'line-dasharray': [2, 2],
            'line-opacity': 1,
        },
    },
    {
        id: 'boundary_country',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'boundary',
        filter: ['==', 'admin_level', 2],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': 'rgb(230, 204, 207)',
            'line-width': ['interpolate', ['exponential', 1.1], ['zoom'], 3, 1, 22, 20],
            'line-blur': ['interpolate', ['linear'], ['zoom'], 3, 0.4, 22, 4],
        },
    },
    {
        id: 'place_other',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 14,
        filter: [
            'all',
            ['in', 'class', 'continent', 'hamlet', 'neighbourhood', 'isolated_dwelling'],
            ['==', '$type', 'Point'],
        ],
        layout: {
            'text-size': 10,
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'center',
            visibility: 'visible',
            'text-offset': [0.5, 0],
            'text-anchor': 'center',
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
        },
    },
    {
        id: 'place_suburb',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 15,
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'suburb']],
        layout: {
            'text-size': 10,
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'center',
            visibility: 'visible',
            'text-offset': [0.5, 0],
            'text-anchor': 'center',
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
        },
    },
    {
        id: 'place_village',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 14,
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'village']],
        layout: {
            'text-size': 10,
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'left',
            visibility: 'visible',
            'text-offset': [0.5, 0.2],
            'icon-size': 0.4,
            'text-anchor': 'left',
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
            'icon-opacity': 0.7,
        },
    },
    {
        id: 'place_town',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 15,
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'town']],
        layout: {
            'text-size': 10,
            'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'left',
            visibility: 'visible',
            'text-offset': [0.5, 0.2],
            'icon-size': 0.4,
            'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
            'icon-opacity': 0.7,
        },
    },
    {
        id: 'place_city',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 14,
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['all', ['!=', 'capital', 2], ['==', 'class', 'city'], ['>', 'rank', 3]],
        ],
        layout: {
            'text-size': 10,
            'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'left',
            visibility: 'visible',
            'text-offset': [0.5, 0.2],
            'icon-size': 0.4,
            'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
            'icon-opacity': 0.7,
        },
    },
    {
        id: 'place_capital',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 12,
        filter: ['all', ['==', '$type', 'Point'], ['all', ['==', 'capital', 2], ['==', 'class', 'city']]],
        layout: {
            'text-size': 14,
            'icon-image': ['step', ['zoom'], 'star-11', 8, ''],
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'left',
            visibility: 'visible',
            'text-offset': [0.5, 0.2],
            'icon-size': 1,
            'text-anchor': ['step', ['zoom'], 'left', 8, 'center'],
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
            'icon-opacity': 0.7,
        },
    },
    {
        id: 'place_city_large',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 12,
        filter: [
            'all',
            ['==', '$type', 'Point'],
            ['all', ['!=', 'capital', 2], ['<=', 'rank', 3], ['==', 'class', 'city']],
        ],
        layout: {
            'text-size': 14,
            'icon-image': ['step', ['zoom'], 'circle-11', 8, ''],
            'text-transform': 'uppercase',
            'text-font': ['Open Sans Regular'],
            'text-justify': 'left',
            visibility: 'visible',
            'text-offset': [0.5, 0.2],
            'icon-size': 0.4,
            'text-field': '{name:latin}\n{name:nonlatin}',
        },
        paint: {
            'text-color': 'rgb(117, 129, 145)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
            'icon-opacity': 0.7,
        },
    },
    {
        id: 'place_state',
        type: 'symbol',
        source: 'openmaptiles',
        'source-layer': 'place',
        maxzoom: 12,
        filter: ['all', ['==', '$type', 'Point'], ['==', 'class', 'state']],
        layout: {
            visibility: 'visible',
            'text-field': '{name:latin}\n{name:nonlatin}',
            'text-font': ['Open Sans Regular'],
            'text-transform': 'uppercase',
            'text-size': 10,
        },
        paint: {
            'text-color': 'rgb(113, 129, 144)',
            'text-halo-color': 'rgb(242,243,240)',
            'text-halo-width': 1,
            'text-halo-blur': 1,
        },
    },
]

export default layers
